import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["data-only-validate-for"]
const _hoisted_3 = { class: "d-flex flex-row" }
const _hoisted_4 = ["data-only-validate-for"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "ci ci-export-to-pdf" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["data-only-validate-for"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-lg" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DateInput = _resolveComponent("DateInput")!

  return (!this.deleted)
    ? (_openBlock(), _createElementBlock("tr", _hoisted_1, [
        _createElementVNode("td", null, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((this.documentReference.realm) = $event)),
            "data-only-validate-for": _ctx.onlyValidateFor,
            disabled: true
          }, null, 8, _hoisted_2), [
            [_vModelText, this.documentReference.realm]
          ])
        ]),
        _createElementVNode("td", null, [
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              required: "",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((this.documentReference.reference) = $event)),
              "data-only-validate-for": _ctx.onlyValidateFor,
              disabled: true
            }, null, 8, _hoisted_4), [
              [_vModelText, this.documentReference.reference]
            ]),
            (this.documentReference.attachmentFilename != null)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  disabled: this.disabled,
                  class: "btn btn-sm",
                  "data-bs-toggle": "tooltip",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.openFile()), ["prevent"]))
                }, _hoisted_7, 8, _hoisted_5))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("td", null, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((this.documentReference.gz) = $event)),
            "data-only-validate-for": _ctx.onlyValidateFor,
            disabled: true
          }, null, 8, _hoisted_8), [
            [_vModelText, this.documentReference.gz]
          ])
        ]),
        _createElementVNode("td", null, [
          _createVNode(_component_DateInput, {
            utcSeconds: this.documentReference.created,
            "onUpdate:utcSeconds": _cache[4] || (_cache[4] = ($event: any) => ((this.documentReference.created) = $event)),
            "data-only-validate-for": _ctx.onlyValidateFor,
            disabled: true
          }, null, 8, ["utcSeconds", "data-only-validate-for"])
        ]),
        _createElementVNode("td", null, [
          _createElementVNode("button", {
            disabled: this.disabled,
            type: "button",
            class: "btn btn-danger",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.doDelete && _ctx.doDelete(...args)))
          }, _hoisted_11, 8, _hoisted_9)
        ])
      ]))
    : _createCommentVNode("", true)
}